import React from "react";

const SectionTwo = () => {
  return (
    <div className="section_two" id="sectionTwo">
      <div className="section_color_card"></div>
      <div className="section_description">
        <h1>
          air ! <br />
          road! <br />
          seaway! <br />
        </h1>
        <p>we get you to where you belong</p>
      </div>
    </div>
  );
};

export default SectionTwo;
